// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import bowser from 'bowser'

import Vue from 'vue'
import App from './App'

import './css/style.less'

import VILLA_DATA from './villa-data.js'

Vue.config.productionTip = false

/* eslint-disable no-new */

const unsupported = bowser.isUnsupportedBrowser({
  msie: '11',
  firefox: '39',
  chrome: '43',
  safari: '9.1',
  opera: '16',
  phantom: '534'
})

new Vue({
  el: '#app',
  data: {
    modalState: {
      show: false,
      caption: '',
      imagelist: [],
      unsupported
    },
    villas: VILLA_DATA.slice(),
    isLoading: true
  },

  mounted () {
    this.$on('lightboxevent', this.openModal)
  },

  methods: {
    handleClick (ev) {
      console.log(ev)
    },

    openModal (v) {
      this.modalState.show = true
      this.modalState.imagelist = v.imagelist
      this.modalState.caption = v.caption
    }
  },

  components: { App },

  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js